const agrupadoresPlazasRoutes = [
    {
      path: "/agrupadores-plazas",
      name: "agrupadores-plaza",
      component: () => import("../AgrupadoresPlaza.vue"),
    },
  ];
  
  export default agrupadoresPlazasRoutes;